import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'element-plus/dist/index.css'
import './assets/css/index.scss'

const app = createApp(App)
app.use(router) //注册路由
app.mount('#app')
